import { __awaiter } from "tslib";
class PriorityStore {
    constructor(storages) {
        this.storages = storages;
    }
    set(key, value) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // Always use the first storage in the array
            yield ((_b = (_a = this.storages[0]).set) === null || _b === void 0 ? void 0 : _b.call(_a, key, value));
        });
    }
    save() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // Always use the first storage in the array
            yield ((_b = (_a = this.storages[0]).save) === null || _b === void 0 ? void 0 : _b.call(_a));
        });
    }
    get(key) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Iterate through the storages in order until a value is found
            for (const storage of this.storages) {
                // eslint-disable-next-line no-await-in-loop
                const value = yield ((_a = storage.get) === null || _a === void 0 ? void 0 : _a.call(storage, key));
                if (value) {
                    return value;
                }
            }
            return null;
        });
    }
}
export default PriorityStore;
